import challengesData from './challenges-lv1.json';
import { Challenge } from '../domain/types';

export const challenges: Challenge[] = challengesData as Challenge[];

export const getRandomChallenges = (count: number = 5): Challenge[] => {
  const shuffled = [...challenges].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count).map(challenge => ({
    ...challenge,
    options: [...challenge.options].sort(() => Math.random() - 0.5)
  }));
};

export const getItemEmoji = (item: string): string => {
  const emojis: Record<string, string> = {
    flower: '🌸',
    crown: '👑',
    gem: '💎',
    unicorn: '🦄'
  };
  return emojis[item] || '✨';
};
